<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-5">
                <div class="card-title" v-once>
                    <span v-if="editing">Категория товара – {{ entry.name }}</span>
                    <span v-else>Создать категорию товара</span>
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <text-field
                            class="px-2 w-1/2"
                            title="Название"
                            v-model="entry.name"
                            :errors="errors.name"
                            required
                        />

                        <select-field
                            class="w-1/2 px-2"
                            title="Родительская категория"
                            label="name"
                            valueName="id"
                            :clearable="true"
                            :options="categories"
                            v-model="entry.parent_id"
                        />
                    </div>

<!--                    <div class="flex -mx-2">
                        <select-field
                            class="w-1/2 px-2"
                            title="Воронка amoCRM"
                            label="name"
                            valueName="id"
                            :clearable="true"
                            :options="selects.pipelines"
                            @input="setPipeline"
                            v-model="pipeline_id"
                        />

                        <select-field
                            v-if="pipeline && pipeline.id"
                            class="w-1/2 px-2"
                            title="Статус amoCRM"
                            label="name"
                            valueName="id"
                            :clearable="true"
                            :options="pipeline.statuses"
                            v-model="entry.status_id"
                        />
                    </div>-->

                    <div class="flex -mx-2">
                        <text-field
                            class="px-2 w-1/4"
                            title="Иконка"
                            v-model="entry.icon"
                            :errors="errors.icon"
                            required
                        />
                    </div>

                    <label class="flex mb-3">
                        <input type="checkbox" class="form-checkbox mt-1" v-model="entry.is_unique" />

                        <div class="ml-2">
                            <div
                                class="text-gray-800 text-gray-700 text-sm tracking-wider"
                            >Уникальный</div>

                            <div
                                class="text-sm text-gray-600"
                            >Для неуникальных товаров ID генерируются автоматически и может быть указано количество в наличии</div>
                        </div>
                    </label>

                    <label class="flex mb-3">
                        <input
                            type="checkbox"
                            class="form-checkbox mt-1"
                            v-model="entry.has_children"
                        />

                        <div class="ml-2">
                            <div
                                class="text-gray-800 text-gray-700 text-sm tracking-wider"
                            >Может иметь подкатегории</div>

                            <div class="text-sm text-gray-600">Например, аксессуары, чехлы, одежда</div>
                        </div>
                    </label>

                    <label class="flex mb-3">
                        <input type="checkbox" class="form-checkbox mt-1" v-model="entry.rentable" />

                        <div class="ml-2">
                            <div class="text-gray-800 text-gray-700 text-sm tracking-wider">Аренда</div>

                            <div class="text-sm text-gray-600">Возможность сдавать товары в аренду</div>
                        </div>
                    </label>

                    <hr class="mb-3" />

                    <button class="btn btn-primary">Сохранить</button>

                    <button v-if="editing" @click.prevent="destroy" class="btn btn-danger">Удалить</button>
                </form>
            </div>

            <products-index v-if="editing" :parentId="entry.id" />
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import ProductsIndex from "./index";

export default {
    extends: ResourceForm,
    components: { ProductsIndex },

    props: {
        parentId: [Number, String]
    },

    data() {
        return {
            resource: {
                name: "admin.products.categories",
                endpoint: "admin/products/categories"
            },

            entry: {
                parent_id: this.parentId,
                is_unique: false,
                has_children: false,
                rentable: false
            },

            selects: {
                ready: false,
                pipelines: []
            },

            pipeline_id: null,
            pipeline: {},
            categories: []
        };
    },

    methods: {
        setPipeline() {
            this.pipeline = this.selects.pipelines.find(
                pipeline => pipeline.id == this.pipeline_id
            );
        },

        async fetchSelects() {
            axios
                .get("admin/products/categories?filters[has_children]=1")
                .then(response => {
                    this.categories = response.data.data;
                });

            await axios.get("admin/crm/settings").then(response => {
                this.selects.pipelines = response.data.data.pipelines;
            });

            let vm = this;
            this.pipeline = this.selects.pipelines.find(pipeline => {
                return !!pipeline.statuses.find(status => {
                    return status.id == vm.entry.status_id;
                });
            });

            if (this.pipeline) {
                this.pipeline_id = this.pipeline.id;
            }

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>
